import React, { FC } from 'react';
import { TNavigationBarProps } from '../@shared/sharedBreadcrumbBar/types/breadcrumbBar.types';
import SharedBreadcrumbBar from '../@shared/sharedBreadcrumbBar';
import { useLocation } from 'react-router-dom';

const DealerLocatorBreadcrumbBar: FC<TNavigationBarProps> = (props: TNavigationBarProps) => {
    const location = useLocation();
    
    const appendQueryParams = (url: string): string => {
      if (!location?.pathname || !location?.search) {
        return url;
      }

      // Dealer detail page URL pattern: .../dealer-landing-page/dealer-name/dealer-number
      // Remove last two segments from URL to get Dealer Landing page and append query string
      const dealerLandingUrlSegments = location?.pathname?.split('/');
      const dealerLandingUrl = dealerLandingUrlSegments?.slice(0, dealerLandingUrlSegments.length - 2)?.join('/');

      if (decodeURI(dealerLandingUrl) === url) {
        return `${url}${location.search}`;
      }

      return url;
    };

    return (
      <SharedBreadcrumbBar appendQueryParams={appendQueryParams} {...props} />
    );
  };

export default DealerLocatorBreadcrumbBar;
